import { createStore, combineReducers, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";

import { categoriesReducer } from "./categories/reducers";
import { baseReducer } from "./base/reducers";
import { formsReducer } from "./forms/reducers";
import { postsReducer } from "./posts/reducers";
import { chartsReducer } from "./charts/reducers";
import { commoditiesReducer } from "./commodities/reducers";

const rootReducer = combineReducers({
    categories: categoriesReducer,
    base      : baseReducer,
    forms     : formsReducer,
    posts     : postsReducer,
    charts    : chartsReducer,
    commodities: commoditiesReducer
});

export type AppState = ReturnType<typeof rootReducer>;

export default function configureStore() {
  const middlewares = [thunkMiddleware];
  const middleWareEnhancer = applyMiddleware(...middlewares);

  const store = createStore(
    rootReducer,
    composeWithDevTools(middleWareEnhancer)
  );

  return store;
}